module.exports = __webpack_public_path__ + "img/icon-skip.bb441141.svg";